import { Box, Typography } from "@mui/joy";
import type { ProductWithPrice } from "../types";

interface OrderTotalProps {
    items: ProductWithPrice[];
}

export function OrderTotal({ items }: OrderTotalProps) {
    const total = items.reduce((sum, item) => sum + (item.Total || 0), 0);
    const hasItemsWithoutPrice = items.some((item) => !item.UnitPrice || item.UnitPrice === 0);

    return (
        <Box display={"flex"} justifyContent={"flex-end"} mt={2} alignItems={"center"} gap={2}>
            <Box flex={1}>
                <Typography></Typography>
            </Box>
            <Box width={190}>
                <Typography level="title-sm">Total</Typography>
                <Typography level="h3">
                    ${total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </Typography>
                {hasItemsWithoutPrice && (
                    <Typography level="body-xs" sx={{ color: "text.secondary", mt: 0.5 }}>
                        * Some items have no price
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
